var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.$store.state.dingding === 'dingtalk' && _vm.isSpecialData.projectStr)?void 0:_c('router-view')],2)}
var staticRenderFns = []

export { render, staticRenderFns }